export default "__VITE_ASSET__DVeJkyYh__"